export const filtersTypes = [
    {
        name: "Etiquetas",
        value: "Etiquetas",
        type: "checkbox",
        key: "tags",
        items: [],
        range: {
            start: 5000,
            end: 200000,
            step: 10000
        }
    },
    {
        name: "Precio",
        value: "Precio",
        type: "range",
        key: "priceOffer",
        items: [],
        range: {
            start: 5000,
            end: 200000,
            step: 10000
        }
    }
];
